import { ProductCategory } from "@utils/constants";
import { PdpSections } from "@utils/customization";
import { useGetPdpSectionLayout } from "../../../hooks/useGetSectionLayout";

interface UsePdpSectionLayoutsProps {
  product_type: ProductCategory;
}

export const usePdpSectionLayouts = ({
  product_type,
}: UsePdpSectionLayoutsProps) => {
  const findMatchSectionLayout = useGetPdpSectionLayout(
    PdpSections.FIND_MATCH,
    product_type
  );

  const priceDisclaimerLayout = useGetPdpSectionLayout(
    PdpSections.PRICE_DISCLAIMER,
    product_type
  );

  const mediaSectionLayout = useGetPdpSectionLayout(
    PdpSections.MEDIA,
    product_type
  );

  const commentsLayout = useGetPdpSectionLayout(
    PdpSections.COMMENTS,
    product_type
  );

  const supplierSectionLayout = useGetPdpSectionLayout(
    PdpSections.SUPPLIER_DETAILS,
    product_type
  );

  const personalizationSectionLayout = useGetPdpSectionLayout(
    PdpSections.PERSONALIZATION,
    product_type
  );

  const refundPolicyLayout = useGetPdpSectionLayout(
    PdpSections.REFUND_POLICY,
    product_type
  );

  return {
    findMatchSectionLayout,
    priceDisclaimerLayout,
    mediaSectionLayout,
    commentsLayout,
    supplierSectionLayout,
    personalizationSectionLayout,
    refundPolicyLayout,
  };
};
